<template>
  <page-view title="调研服务费">
    <template slot="action">
      <a-button class="ml-1 mr-1" type="primary" icon="rollback" @click="$router.go(-1)">返回</a-button>
    </template>
    <a-card>
      <a-form-model ref="form" :model="model" :rules="rules" class="pick-100">
        <a-row type="flex" class="form-input about">
          <a-col :span="24">
            <a-form-model-item label="调研服务费" prop="serviceFee">
                              <span class="d-inline-block">
                                 <a-input-number placeholder="调研服务费" style="width: 100%"
                                                 :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                                 v-model="model.serviceFee"
                                                 :min="0"
                                 />
                            </span>
              <span class="d-inline-block" style="margin-left: 10px">元</span>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div style="text-align: center">
        <a-space>
          <a-button type="primary" :loading="butLoading" @click="onSave" icon="save">{{
              isSave ? '已保存' : '保存'
            }}
          </a-button>
          <a-popconfirm title="是否确认删除?" @confirm="onDelete">
            <a-button v-if="isSave" type="primary" :loading="butLoading" icon="delete">清除数据
            </a-button>
          </a-popconfirm>
        </a-space>
      </div>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import { AddOrUpdateBidXqDcFwf, DeleteFee, GetVoByXmId } from '@/views/demandsurveybid/servicefee/api/FeeRequest'

export default {
  name: 'ServiceFeeForm',
  components: {
    PageView,
  },
  data () {
    return {
      rules: {
        serviceFee: [{ required: true, message: '请输入调研服务费', trigger: 'change' }],
      },
      xmId: this.$route.query.xmid,
      model: {
        serviceFee: null,
        id: undefined
      },
      butLoading: false,
      isSave: false
    }
  },
  created () {
    this.getServiceFee()
  },
  methods: {
    //获取调研服务费
    async getServiceFee () {
      try {

        let res = await GetVoByXmId(this.xmId)
        if (res.code === 200) {
          this.isSave = !!(res.result && res.result.id)
          this.model = res.result || { serviceFee: null, id: undefined }
        }
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async onDelete () {
      try {
        this.butLoading = true
        let res = await DeleteFee(this.model.id)
        if (res.code === 200) {
          this.$message.success('清除成功')
          await this.getServiceFee()
        } else {
          this.$message.error('清除失败')
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.butLoading = false
      }
    },
    //保存调研服务费
    onSave () {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          this.butLoading = true
          const data = { ...this.model }
          data.projectId = this.xmId
          let res = await AddOrUpdateBidXqDcFwf(data)
          if (res.code === 200) {
            this.$message.success('保存成功')
            await this.getServiceFee()
          } else {
            this.$message.error('保存失败')
          }
        } catch (e) {
          this.$message.error(e.message)
        } finally {
          this.butLoading = false
        }
      })

    }
  }
}
</script>

<style scoped>

</style>
